/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ComponentType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ComponentType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ComponentType_ {
   /// <summary>
   ///   None (None)
   /// </summary>
   None = 0,
   /// <summary>
   ///   Video Library (vidlib)
   /// </summary>
   VideoLibrary = 1,
   /// <summary>
   ///   Course Library (cslib)
   /// </summary>
   CourseLibrary = 2,
   /// <summary>
   ///   Booking (book)
   /// </summary>
   Booking = 3,
   /// <summary>
   ///   Featured Video Experience (featured)
   /// </summary>
   FeaturedVideoExperience = 4,
   /// <summary>
   ///   Video Playlist (playlist)
   /// </summary>
   VideoPlaylist = 5
}

export const ComponentTypes: ComponentType[] = [
   {
      code: ComponentType_.None,
      literal: 'None',
      description: 'None',
      shortDescription: 'None',
      listPriority: 0,

      typeName: "ComponentType"
   },
   {
      code: ComponentType_.VideoLibrary,
      literal: 'VideoLibrary',
      description: 'Video Library',
      shortDescription: 'vidlib',
      listPriority: 0,

      typeName: "ComponentType"
   },
   {
      code: ComponentType_.CourseLibrary,
      literal: 'CourseLibrary',
      description: 'Course Library',
      shortDescription: 'cslib',
      listPriority: 0,

      typeName: "ComponentType"
   },
   {
      code: ComponentType_.Booking,
      literal: 'Booking',
      description: 'Booking',
      shortDescription: 'book',
      listPriority: 0,

      typeName: "ComponentType"
   },
   {
      code: ComponentType_.FeaturedVideoExperience,
      literal: 'FeaturedVideoExperience',
      description: 'Featured Video Experience',
      shortDescription: 'featured',
      listPriority: 0,

      typeName: "ComponentType"
   },
   {
      code: ComponentType_.VideoPlaylist,
      literal: 'VideoPlaylist',
      description: 'Video Playlist',
      shortDescription: 'playlist',
      listPriority: 0,

      typeName: "ComponentType"
   }
]

export class ComponentType implements IDomainModel {
   code: ComponentType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: ComponentType_): ComponentType {
      return ComponentTypes.find(d => d.code === code)
   }
}
